export interface PersonFormGroupDTO {
  nameDetails: NameDetailsDTO;
  otherInformation: OtherInformationDTO;
  undeliverableToPrimaryAddress: boolean;
  primaryAddress: AddressListFormGroupDTO;
  secondaryAddress: AddressListFormGroupDTO;
  phones: PhoneTypeFormControl[];
  emails: EmailMarketing[];
  declinedOrHasNoEmailAddress: boolean;
  preferredContactMethod: string;
  notes: string;
}

interface EmailMarketing {
  email: string;
  marketing: boolean;
}

export interface NameDetailsDTO {
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  maidenName: string;
  pronounUid: string[];
  akaFirstName: string;
  akaLastName: string;
}

export interface OtherInformationDTO {
  genderUid: string[];
  birthGenderUid: string[];
  genderIdentityUid: string[];
  sexualOrientationUid: string[];
  birthDate: Date;
  deathDate: Date | null;
  maritalStatusUid: string[];
  raceUids: string[];
  ethnicityUids: string[];
  preferredLanguageUid: string[];
  translatorRequired: boolean;
  dominantHandUid: string[];
  socialSecurityNumber: string;
  driversLicenseNumber: string;
  driversLicenseState: string;
}

export interface PhoneTypeFormControl {
  phoneNumber: string;
  phoneType: string;
  phoneTypeUid: string;
  marketing?: boolean;
}

export interface AddressListFormGroupDTO {
  addressOne?: string;
  addressTwo?: string;
  city?: string;
  state?: string;
  zip?: string;
  zipUid?: string;
  country?: string;
  countyName?: string;
  countyCode?: string;
}

export enum EResponsiblePartyType {
  CORPORATION = 'Corporation',
  PERSON = 'Person'
}
